const initialState = {
    networks: []
};

export const networkNavigatorReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case 'INVENTORY_VIEW_SUCCESS':
            return {
                ...initialState,
                networks: action.networks
            };

        default:
            return state;
    }
};
